import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { useAppState } from '../../overmind'
import ProfileCard from './ProfileCard'
import ProfileForm from './ProfileForm'
import ProfileHero from './ProfileHero'
import ProfileInfo from './ProfileInfo'
import SignupText from './SignupText'


const Profile = () => {
    const state = useAppState()
    const navigate = useNavigate()
    const location = useLocation()
    // Holds a local state to check whether the user is editing their user information or not
    const [editing, setEditing] = useState(!state.isValid)
    // Tracks the previous validity so we can default back to edit mode when it turns invalid.
    const [prevIsValid, setPrevIsValid] = useState(state.isValid)

    // Redirect from "/" to "/profile" when user object is invalid
    useEffect(() => {
        if (!state.isLoggedIn) {
            navigate("/")
        } else if (!state.isValid && location.pathname === "/") {
            navigate("/profile")
        }
    }, [state.isLoggedIn, state.isValid, location.pathname, navigate])

    // Adjust state during render (not in an Effect) per React's recommended pattern:
    // https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes
    if (state.isValid !== prevIsValid) {
        setPrevIsValid(state.isValid)
        if (!state.isValid) {
            setEditing(true)
        }
    }

    return (
        <div className="min-h-screen">
            <ProfileHero name={state.self.Name} />
            <div className="container mx-auto px-4 py-12 flex justify-center">
                <ProfileCard>
                    {editing ?
                        <ProfileForm setEditing={setEditing} >
                            {state.isValid ? null : <SignupText />}
                        </ProfileForm>
                        : <ProfileInfo setEditing={setEditing} />
                    }
                </ProfileCard>
            </div>
        </div>
    )
}

export default Profile
